import { Box, LinearProgress } from '@mui/material';
import { Suspense } from 'react';

// this will show the animation
const Loader = () => {
    return (
        <Box sx={{ position: "fixed", width: "100%", top: 0, left: 0, zindex: 9999 }} >
            <LinearProgress color="secondary" />
        </Box>
    );
};

const MprcLoadable = (Component: any) => (props: any) => (
    <Suspense fallback={<Loader />}>
        <Component {...props} />
    </Suspense>
);

export default MprcLoadable;
